'use strict'

export default {
  properties: {},
  events: {}
}
